export class LoggedInUser {
    JWTToken: string;
    firstName: string;
    lastName: string;
    email: string;
}
